<template>
	<label :class="variantCls.root" v-on="$listeners"><slot /></label>
</template>

<script>
export default {
	props: {
		variant: {
			type: String,
			default: "default"
		}
	},

	computed: {
		variantCls() {
			return this.$store.getters.variants("JLabel", this.variant).el
		}
	}
}
</script>
